import styled from '@emotion/styled';

const LoadingContainer = styled('div')({
  display: 'table',
  height: '8rem',
  width: '100%',
});

export default LoadingContainer;
